<template>
    <div class="flexcol-fill overflow-hidden">
        <v-container v-if="timer.length < 5" fluid class="flexcol-fix text-center">
            <v-btn color="primary" @click="addTimer" size="large"><v-icon icon="mdi-plus-circle-outline" class="mr-2"/> Timer hinzufügen</v-btn>
        </v-container>
        <v-container fluid class="flexcol-fill overflow-auto">
            <v-row v-for="t in timer" v-bind:key="t.id">
                <v-col>
                    <kc-timer v-model="t.timerData" @remove="removeTimer(t)"/>
                </v-col>
            </v-row>      
        </v-container>
    </div>
</template>
<script>
const STORAGE_VAR_TIMERS = 'kc.timers';
import kcTimer from './timer.vue';
export default {
    name: 'kc-clock',
    components: {
        kcTimer
    },
    data() {
        return {   
            timer: []         
        }
    },
    props: {
        withDigits: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        time() {
            const vm = this;
            return vm.$dayjs().format('HH:mm');            
        }
    },
    watch: {
        timers: {
            deep: true,
            handler() {
                const vm = this;
                localStorage[STORAGE_VAR_TIMERS] = JSON.stringify(vm.timers);
            }
        }
    }, 
    methods: {
        addTimer() {
            const vm = this;
            var t = {
                id: vm.newId(),
                timerData: {
                    text: 'Mein Timer',
                    startTime: 420,
                    timer: 420
                }
            }
            vm.timer.push(t);
        },
        removeTimer(t) {
            const vm = this;
            var index = vm.timer.indexOf(t);
            if (index > -1) {
                vm.timer.splice(index, 1);
            }
        },
        newId() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        }        
    }
}
</script>
<style lang="sass" scoped>
</style>